/**
 * Renata Mini — hub de negocio (español).
 */
import { createFileRoute, Link } from "@tanstack/react-router";
import {
  Flag, Zap, Target, CheckCircle2, Bell, BookOpen,
  Sparkles, Workflow, Mic, Map, ArrowRight, BookMarked, Inbox,
} from "lucide-react";

export const Route = createFileRoute("/renata/os")({
  component: RenataMiniOs,
  head: () => ({ meta: [{ title: "Renata" }] }),
});

const LINKS = [
  { to: "/app/renata/goals", label: "Objetivos", icon: Flag, hint: "Qué querés lograr" },
  { to: "/app/renata/tasks", label: "Acciones", icon: Zap, hint: "Pasos concretos" },
  { to: "/app/renata/missions", label: "Planes de trabajo", icon: Target, hint: "Planes activos" },
  { to: "/app/renata/chat", label: "Aprobaciones", icon: CheckCircle2, hint: "Revisar y confirmar" },
  { to: "/app/renata/push", label: "Avisos push", icon: Bell, hint: "Borradores de campaña" },
  { to: "/app/renata/playbooks", label: "Guías de trabajo", icon: BookOpen, hint: "Procesos reutilizables" },
  { to: "/app/renata/planning", label: "Planificador", icon: Map, hint: "Armar el camino" },
  { to: "/app/renata/inbox", label: "Captura", icon: Inbox, hint: "Foto / PDF / documentos" },
  { to: "/app/renata/knowledge", label: "Biblioteca", icon: BookMarked, hint: "Buscar y citar" },
  { to: "/app/renata/learning", label: "Aprendizajes", icon: Sparkles,
  Workflow, hint: "Mejoras con tu OK" },
  { to: "/renata/", label: "Voz", icon: Mic, hint: "Hablar con Renata" },
];

function RenataMiniOs() {
  return (
    <div className="mx-auto max-w-lg space-y-4 p-4">
      <div>
        <h1 className="text-xl font-semibold">Renata</h1>
        <p className="text-sm text-muted-foreground">
          Tu asistente del negocio. Elegí qué querés hacer ahora.
        </p>
      </div>
      <div className="grid gap-2">
        {LINKS.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className="flex items-center gap-3 rounded-xl border p-3 hover:bg-muted/40"
          >
            <l.icon className="h-5 w-5 shrink-0" />
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium">{l.label}</p>
              <p className="text-xs text-muted-foreground">{l.hint}</p>
            </div>
            <ArrowRight className="h-4 w-4 text-muted-foreground" />
          </Link>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">Tu siguiente paso es elegir un área o abrir la conversación.</p>
    </div>
  );
}
